import React from 'react';
import { Button, Modal } from 'ui-kit';
import './HostawayIntroModal.scss';

export interface IHostawayIntroModal {
  isOpen: boolean;
  onCancel: () => void;
}

const HostawayIntroModal = ({ isOpen, onCancel }: IHostawayIntroModal) => {
  return (
    <Modal
      visible={isOpen}
      onCancel={onCancel}
      title={'Your stores are ready!'}
      width={650}
      footer={null}
    >
      <div className="HostawayIntroModalCtn">
        <p>Next steps:</p>
        <ol className="action-list">
          <li className="action-list_item">
            Modify stores to reflect your prices, descriptions and any new products (you can also
            modify one main store and duplicate it).
          </li>
          <li className="action-list_item">
            Hit &quot;share&quot; in the upper right corner to see your store link, guest message
            templates, and icon to take you back to Hostaway.
          </li>
          <li className="action-list_item">
            Add your store links in your outgoing Hostaway messages by hitting &quot;+Add
            variable&quot; and selecting &quot;listing_hostco&quot;
          </li>
        </ol>
        <p>
          Want help setting up your stores? Got questions?{' '}
          <a href="https://calendly.com/hostcodemo/host-co-demo" target="_blank" rel="noreferrer">
            Join us for a daily demo and Q&A here.
          </a>
        </p>
        <div className="button_ctn">
          <Button variant="contained" onClick={() => onCancel()}>
            Let&apos;s Go!
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default HostawayIntroModal;
